import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
    GET_DIAGNOSES,
    GET_MES_VISITES,
    GET_LIST,
    GET_APPEALS,
    GET_VACCINE_EXCLUSIONS,
    GET_VACCINATION_MODAL
} from "../types";

export const getDiagnoses = (year) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/diagnoses`);
        dispatch({ type: GET_DIAGNOSES, payload: data });
    } catch (error) {
    }
};

export const getMedVisites = (year) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/med_visites`);
        dispatch({ type: GET_MES_VISITES, payload: data });
    } catch (error) {
    }
};

export const getList = (params) => async (dispatch, getState) => {
    try {
        const urlParams = new URLSearchParams(params).toString();
        const { data } = await api.get(`/people/medcards?${urlParams}`);
        dispatch({ type: GET_LIST, payload: data });
    } catch (error) {
    }
};

export const getAppeals = (id) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/med_visites/recourse/${id}`);
        dispatch({ type: GET_APPEALS, payload: data });
    } catch (error) {
    }
};

export const createMedVisites = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/med_visites`, data);
        await dispatch(getAppeals(data.mid));
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};
export const updateMedVisites = ({ mid, idmedvisit, ...data }) => async (dispatch, getState) => {
    try {
        await api.put(`/med_visites/${idmedvisit}`, data);
        await dispatch(getAppeals(mid));
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось обновить запись");
    }
};

//Противопоказания
export const getVaccineExclusionsModal = (mid) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/vaccine_exclusions/contraindications/${mid}`);
        dispatch({ type: GET_VACCINE_EXCLUSIONS, payload: data });
    } catch (error) {
    }
};

export const createVaccineExclusionsModal = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/vaccine_exclusions`, data);
        createNotification('success', 'Успешно');
        await dispatch(getVaccineExclusionsModal(data.mid));
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};
//ПРИВИВКА
export const getVaccinationModal = (mid) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/f_vaccination/inoculations/${mid}`);
        dispatch({ type: GET_VACCINATION_MODAL, payload: data });
    } catch (error) {
    }
};

export const createVaccinationModal = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/f_vaccination`, data);
        createNotification('success', 'Успешно');
        await dispatch(getVaccinationModal(data.mid));
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};